import { productionLineMonitorResponseSchema } from "../../../shared/production/line-monitor";

export class LineMonitorReadError extends Error {
  constructor(readonly status: number, message: string) { super(message); }
}

export async function readProductionLineMonitor(signal: AbortSignal, fetcher: typeof fetch = fetch) {
  const response = await fetcher("/api/production/line-monitor/tamtas-silindir", {
    credentials: "same-origin", cache: "no-store", signal,
    headers: { accept: "application/json" },
  });
  if (response.redirected) throw new LineMonitorReadError(401, "Oturum doğrulanamadı.");
  if (!response.ok) throw new LineMonitorReadError(response.status, "Hat verisi alınamadı.");
  if (!response.headers.get("content-type")?.includes("application/json")) {
    throw new LineMonitorReadError(404, "Bu sunucuda canlı hat izleme servisi henüz etkin değil.");
  }
  const raw: unknown = await response.json();
  return productionLineMonitorResponseSchema.parse(raw);
}
